import { createReducer, on } from '@ngrx/store';
import { loadedUserSettings, removeUserSettings } from './core.actions';
import { initialState } from './core.state';

export const coreReducer = createReducer(
  initialState,
  on(loadedUserSettings, (state, { settings }) => ({ ...state, settings })),
  on(removeUserSettings, state => ({ ...state, settings: null })),
);
